import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import cargomate from '../../locales/en/cargomate.json'
import rob from '../../locales/en/rob.json'

const resources = {
  en: {
    translation: {
      ...cargomate.translation,
      ...rob,
    },
  },
}

i18n.use(initReactI18next).init({ lng: 'en', resources })

export default i18n
